import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-606cd98d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tracking-login-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "login-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", null, "Acompanhar visita"),
    /*#__PURE__*/_createElementVNode("small", null, "Acesso do responsável ou professor da visita")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-formulario login-description" }, " Informe o código do agendamento e o seu e-mail para consultar o andamento da visita. ", -1))
const _hoisted_4 = { class: "field w-full" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1))
const _hoisted_6 = { class: "p-input-icon-left w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ticket" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "field w-full" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "obrigatorio" }, " *", -1))
const _hoisted_11 = { class: "p-input-icon-left w-full" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "security-box" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "security-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-shield" }),
  /*#__PURE__*/_createElementVNode("span", null, "Verificação de segurança")
], -1))
const _hoisted_16 = {
  key: 1,
  class: "p-error captcha-config-error"
}
const _hoisted_17 = {
  key: 2,
  class: "p-error captcha-config-error"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "privacy-note" }, " Seus dados de acesso são usados somente para localizar o agendamento. A consulta permanece disponível apenas durante esta sessão do navegador. ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header-erro-forms" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle mr-1" }),
  /*#__PURE__*/_createTextVNode(" ERRO ")
], -1))
const _hoisted_20 = { class: "confirmation-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_HcaptchaWidget = _resolveComponent("HcaptchaWidget")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card, { class: "shadow-5 tracking-login-card" }, {
        title: _withCtx(() => [
          _hoisted_2
        ]),
        content: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", {
              class: _normalizeClass(["w-full", { 'p-error': _ctx.agendamento.codigoAgendamento.erro }]),
              for: "codigo"
            }, [
              _createTextVNode(" Código do Agendamento"),
              _hoisted_5
            ], 2),
            _createElementVNode("span", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_InputText, {
                id: "codigo",
                modelValue: _ctx.agendamento.codigoAgendamento.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agendamento.codigoAgendamento.value) = $event)),
                class: _normalizeClass(["w-full", { 'p-invalid': _ctx.agendamento.codigoAgendamento.erro }]),
                type: "text",
                autocomplete: "off",
                onFocusout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkInput(_ctx.agendamento.codigoAgendamento))),
                onInput: _ctx.changeSchedulingCode
              }, null, 8, ["modelValue", "class", "onInput"])
            ]),
            (_ctx.agendamento.codigoAgendamento.erro)
              ? (_openBlock(), _createElementBlock("small", _hoisted_8, " Informe o código de agendamento "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              class: _normalizeClass(["w-full", { 'p-error': _ctx.agendamento.emailProfessor.erro }]),
              for: "email"
            }, [
              _createTextVNode(" E-mail do Responsável ou Professor"),
              _hoisted_10
            ], 2),
            _createElementVNode("span", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_InputText, {
                id: "email",
                modelValue: _ctx.agendamento.emailProfessor.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agendamento.emailProfessor.value) = $event)),
                type: "email",
                autocomplete: "email",
                class: _normalizeClass(["w-full", { 'p-invalid': _ctx.agendamento.emailProfessor.erro }]),
                onFocusout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkInputEmail(_ctx.agendamento.emailProfessor))),
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeInputEmail(_ctx.agendamento.emailProfessor)))
              }, null, 8, ["modelValue", "class"])
            ]),
            (_ctx.agendamento.emailProfessor.erro)
              ? (_openBlock(), _createElementBlock("small", _hoisted_13, " Informe um e-mail válido "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            (_ctx.hcaptchaSiteKey)
              ? (_openBlock(), _createBlock(_component_HcaptchaWidget, {
                  key: 0,
                  ref: "captchaWidget",
                  "site-key": _ctx.hcaptchaSiteKey,
                  onVerify: _ctx.onCaptchaVerify,
                  onExpired: _ctx.onCaptchaExpired,
                  onError: _ctx.onCaptchaError
                }, null, 8, ["site-key", "onVerify", "onExpired", "onError"]))
              : (_openBlock(), _createElementBlock("small", _hoisted_16, " hCaptcha não configurado. ")),
            (_ctx.captchaError && _ctx.hcaptchaSiteKey)
              ? (_openBlock(), _createElementBlock("small", _hoisted_17, " Conclua novamente a verificação de segurança. "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_Button, {
            class: "p-button-success w-full access-button",
            iconPos: "left",
            icon: "pi pi-sign-in",
            label: "ACESSAR AGENDAMENTO",
            disabled: !_ctx.hcaptchaToken || !_ctx.hcaptchaSiteKey,
            onClick: _ctx.submitForms
          }, null, 8, ["disabled", "onClick"]),
          _hoisted_18
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.erroForms.active,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.erroForms.active) = $event)),
      header: "Erro",
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '380px' },
      modal: true,
      closable: false
    }, {
      header: _withCtx(() => [
        _hoisted_19
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.erroForms.active = false)),
          class: "p-button-danger p-button-sm",
          style: {"margin":"0"},
          label: "Ok",
          icon: "pi pi-check"
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", null, _toDisplayString(_ctx.erroForms.message), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Toast)
  ], 64))
}